import i18next from 'i18next';
import { formatDateTime, formatMoney } from './formattedString';
import { PAYMENT_STATUSES } from 'constants/constants';

export const formatPriceWithDiscount = (record) => {
  return Number(record?.originalPrice) === Number(record?.price) ? (
    <b>{formatMoney(record?.price)}</b>
  ) : (
    <div>
      <i className="description">
        <del>{formatMoney(record?.originalPrice)}</del>
      </i>
      <b style={{ color: '#000' }}>{` ${formatMoney(record.price)}`}</b>
    </div>
  );
};

export const formatDuration = (record) => {
  if (record?.endDate) {
    return `${formatDateTime(record?.startDate)} - ${formatDateTime(
      record?.endDate,
    )}`;
  }
  return `${formatDateTime(record?.startDate)} - ${i18next.t('promotions.noExpiry')}`;
};

export const formatPaymentStatus = (value) => {
  const item = PAYMENT_STATUSES.find((i) => i.value === value);
  return item?.text ? i18next.t(item.text) : value;
};

export const formatPaymentStatusColor = (value) => {
  const item = PAYMENT_STATUSES.find((i) => i.value === value);
  return item?.color ?? value;
};
